import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import reduce from 'lodash/reduce';

var UrlGenerator =
/*#__PURE__*/
function () {
  function UrlGenerator(routes, opts) {
    _classCallCheck(this, UrlGenerator);

    this.routes = routes;
    this.options = _objectSpread({
      paramFormat: '\:{key}(\\([^\\)]*\\))?'
    }, opts);
  }

  _createClass(UrlGenerator, [{
    key: "route",
    value: function route(key, opts) {
      var options = _objectSpread({
        withHost: false
      }, this.options, opts);

      var withHost = options.withHost,
          paramFormat = options.paramFormat,
          params = _objectWithoutProperties(options, ["withHost", "paramFormat"]);

      var route = this.routes[key] || key;
      var url = reduce(params || {}, function (str, v, k) {
        return str.replace(new RegExp(paramFormat.replace(/\{\s*key\s*\}/gi, k), 'i'), v);
      }, route);
      var host = typeof window !== 'undefined' ? "".concat(window.location.protocol, "//").concat(window.location.host) : '';
      var hostPattern = host !== null ? "^".concat(host) : '^$';

      if (typeof withHost !== 'undefined' && withHost === true) {
        return !url.match(hostPattern) ? "".concat(host).concat(url) : url;
      }

      var urlWithoutHost = url.replace(new RegExp(hostPattern, 'i'), '');
      return urlWithoutHost === '' ? '/' : urlWithoutHost;
    }
  }]);

  return UrlGenerator;
}();

export default UrlGenerator;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-container/es/UrlGenerator.js
// module id = null
// module chunks = 